import {useData} from "vike-react/useData";
import {ApiLiveData, ApiStreamer, ApiStreamerCategory} from "#/src/definitions/ApiDefinitions";
import {StreamerCard} from "#/src/pages/live/StreamerCard";
import {Sort} from "#/src/utils/sort-utils";
import {useEffect} from "react";
import queryString from "query-string";
import {DataWrapped} from "#/src/definitions/AppDefinitions";
import {AdSection} from "#/src/pages/live/AdSection";

export function Content() {
  const {data: livePageData} = useData() as DataWrapped<ApiLiveData>;
  useEffect(() => {
    const query = queryString.parse(window.location.search);
    const queryCategory: string = query.category as string;
    if (queryCategory) {
      setTimeout(() => document.getElementById(queryCategory)?.scrollIntoView(), 150);
    }
  }, []);

  function render() {
    return <main>
      <section className="mainlive">
        <div className="container-xxl">
          <div className="row">
            <div className="col-xl-12">
              <div className="title-between flex-wrap py-5">
                <h2 className="basic-headline">Live</h2>
                <div className="flex-list">
                  <span className="d-none d-sm-block d-lg-block text-white">Znajdź coś dla siebie:</span>
                  <ul className="nav-category">
                    {renderCategoriesSelector()}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-4" id={"ekipa"}>
            <div className="col-xl-12">
              <h2 className="basic-headline mb-4">
                Ekipa <span className="text-primary">JaRock</span>
              </h2>
            </div>
            {Sort.byStreamerDisplay(livePageData.streamers.filter(s => s.category.displayPriority == 1))
              .map((streamer: ApiStreamer) => <StreamerCard key={streamer.id} streamer={streamer}/>)}
          </div>
        </div>
      </section>
      <AdSection/>
      {renderCategories()}
    </main>
  }

  function renderCategoriesSelector() {
    return Sort.byDisplayPriority(livePageData.categories).map((category: ApiStreamerCategory, i: number) => {
      return <li key={category.id} className="nav-item">
        <a className={`nav-link ${i == 0 ? "active" : ""}`} href={`#${category.name}`}>{category.name}</a>
      </li>
    });
  }

  function renderCategories() {
    const categories = Sort.byDisplayPriority(livePageData.categories).slice(1);
    return categories.map((category: ApiStreamerCategory, i: number) => {
      return <section key={category.id} className="live-list my-5" id={category.name}>
        <div className={`container-xxl ${i < categories.length - 1 ? 'border-b-dark' : ''}`}>
          <div className="row pb-3">
            <div className="col-xl-12">
              <h2 className="basic-headline mb-4">{category.name}</h2>
            </div>
            {Sort.byStreamerDisplay(livePageData.streamers.filter(s => s.category.id == category.id))
              .map((streamer: ApiStreamer) => <StreamerCard key={streamer.id} streamer={streamer} secondary/>)}
          </div>
        </div>
      </section>
    });
  }

  return render();
}